import { useAppSelector } from '@/store/hooks'

export const useContentLang = () => useAppSelector((s) => s.editor.contentLang)

/**
 * Правится НЕ исходный слот курса. Сравнение идёт с языком, которым редактор
 * засеян при открытии (`seedContentLang` ← `seedLangFor(course)`), а не с
 * константой: у английского курса второй слот — русский.
 *
 * Нужно местам промпта: авто-режим отрисовки рисует только исходный слот
 * (§5.3), поэтому промпт второго языка сохраняется, но не рисуется — молча.
 */
export const useIsSecondaryContentLang = () =>
  useAppSelector(
    (s) => s.editor.seededLang !== null && s.editor.contentLang !== s.editor.seededLang,
  )
